import { Helpers } from '../../helpers';
import { IWellDesign } from '../../interfaces/iwell-design';
import { Well } from '../well';

export class WellDesignBase {
  WellDesignId: number;
  Name: string;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;
  Wells_WellDesign?: Array<Well> | null;

  constructor(item?: IWellDesign) {
    if (item) {
      this.WellDesignId = item.WellDesignId;
      this.Name = item.Name;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;
      this.Wells_WellDesign = Helpers.createClassArray(Well, item.Wells_WellDesign);

    }
  }
}